import { Badge } from "antd";
import { observer } from "mobx-react-lite";
import React, { PropsWithChildren } from "react";
import { useTicketUpdate } from "../../hooks/useTicketUpdate";

type Props = PropsWithChildren<{}>;

export const TicketUpdateBadge = observer((props: Props) => {
  const { hasUpdate } = useTicketUpdate();

  if (!hasUpdate) return <>{props.children}</>;

  return (
    <Badge
      dot
      status="processing"
      styles={{
        indicator: {
          width: 12,
          height: 12,
          userSelect: "none",
          pointerEvents: "none",
        },
      }}
    >
      {props.children}
    </Badge>
  );
});
